export const canAdministerCheckins = (role?: string | null) =>
  role?.toLowerCase() === 'admin';
